/* ============================================================
   HELP  (/help-v3.9)  — SESAAT Studio v3.9
   ============================================================
   ⚠️ Menu "Help" dalam StudioShell dahulunya menghala ke
   /support-group — route itu TIDAK WUJUD di mana-mana dalam
   app. Menu itu tidak membuat apa-apa apabila diklik. Halaman
   ini menggantikannya.

   ⛔ Pautan group sokongan SEBENAR bergantung pada ejen yang
   merujuk pelanggan itu, dan jika tiada, jatuh kepada group
   rasmi mengikut tier (percubaan vs berbayar) —
   officialSupportGroup() dalam services/affiliateService.
   Bila prototaip ini diganti dengan yang sebenar, sambung
   semula ke fungsi itu; jangan hardcode satu pautan untuk
   semua orang.

   ⚠️ PROTOTAIP — pautan di bawah belum bersambung.
   ============================================================ */

import { MessageCircle, PlayCircle, Puzzle, ChevronRight } from 'lucide-react';

import '../design/tokens.css';
import { Btn, PageHeader, Card, CardBody } from '../design/ui';
import { useT } from '../i18n';

const TUTORIAL_PLAYLIST_URL = 'https://www.youtube.com/playlist?list=PLUgKht1i8s1Yo9oEW_L4yUE4o_NWx1oIX';

/* Soalan lazim. Pemalar aras-modul tidak boleh memanggil useT(), jadi
   senarai ini menyimpan KUNCI kamus dan terjemahannya berlaku pada masa
   render di bawah. Kunci ditulis penuh (bukan dibina daripada `id`)
   supaya ia masih boleh dicari dengan grep. */
const SOALAN = [
    { id: 'flow', q: 'dashboard.help.faq.flow.q', a: 'dashboard.help.faq.flow.a' },
    { id: 'kuota', q: 'dashboard.help.faq.quota.q', a: 'dashboard.help.faq.quota.a' },
    { id: 'storage', q: 'dashboard.help.faq.storage.q', a: 'dashboard.help.faq.storage.a' },
    { id: 'browser', q: 'dashboard.help.faq.browsers.q', a: 'dashboard.help.faq.browsers.a' },
];

export default function HelpV39View({ onNavigate }) {
    const t = useT();

    return (
        <div className="sesaat-m-tight" style={{ padding: '26px 28px 48px', maxWidth: 780 }}>

            <PageHeader
                title={t('dashboard.help.title')}
                subtitle={t('dashboard.help.subtitle')}
                actions={<span className="s-dim">{t('dashboard.help.protoNote')}</span>}
            />

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 14, marginBottom: 26 }}>
                <Card hover>
                    <CardBody>
                        <MessageCircle size={18} strokeWidth={1.8} style={{ color: 'var(--s-brand)', marginBottom: 8 }} />
                        <h2 className="s-cardname" style={{ marginBottom: 4 }}>{t('dashboard.help.group.title')}</h2>
                        <p className="s-meta" style={{ fontSize: 13, marginBottom: 10 }}>
                            {t('dashboard.help.group.desc')}
                        </p>
                        <Btn size="sm" icon={<ChevronRight size={14} strokeWidth={2} />}>{t('dashboard.help.group.cta')}</Btn>
                    </CardBody>
                </Card>

                <Card hover>
                    <CardBody>
                        <PlayCircle size={18} strokeWidth={1.8} style={{ color: 'var(--s-ink-2)', marginBottom: 8 }} />
                        <h2 className="s-cardname" style={{ marginBottom: 4 }}>{t('dashboard.help.tutorial.title')}</h2>
                        <p className="s-meta" style={{ fontSize: 13, marginBottom: 10 }}>
                            {t('dashboard.help.tutorial.desc')}
                        </p>
                        <Btn size="sm" variant="ghost" icon={<ChevronRight size={14} strokeWidth={2} />}
                            onClick={() => window.open(TUTORIAL_PLAYLIST_URL, '_blank', 'noopener')}>
                            {t('dashboard.help.tutorial.cta')}
                        </Btn>
                    </CardBody>
                </Card>

                <Card hover>
                    <CardBody>
                        <Puzzle size={18} strokeWidth={1.8} style={{ color: 'var(--s-ink-2)', marginBottom: 8 }} />
                        <h2 className="s-cardname" style={{ marginBottom: 4 }}>{t('dashboard.help.extension.title')}</h2>
                        <p className="s-meta" style={{ fontSize: 13, marginBottom: 10 }}>
                            {t('dashboard.help.extension.desc')}
                        </p>
                        <Btn size="sm" variant="ghost" icon={<ChevronRight size={14} strokeWidth={2} />}
                            onClick={() => onNavigate?.('/extension-v3.9')}>
                            {t('dashboard.help.extension.cta')}
                        </Btn>
                    </CardBody>
                </Card>

            </div>

            <h2 className="s-title" style={{ fontSize: 16, marginBottom: 10 }}>{t('dashboard.help.faqTitle')}</h2>
            <Card>
                <CardBody style={{ paddingTop: 4, paddingBottom: 4 }}>
                    {SOALAN.map((s) => (
                        <div key={s.id} className="s-step" style={{ gap: 0, flexDirection: 'column' }}>
                            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--s-ink)', marginBottom: 4 }}>{t(s.q)}</div>
                            <p className="s-meta" style={{ fontSize: 13 }}>{t(s.a)}</p>
                        </div>
                    ))}
                </CardBody>
            </Card>

        </div>
    );
}
